import {
    SOURCES_I18N_KEYS
  } from '../../../../features/sources/constants/i18n/Sourcesi18nConstants';
  
  export const SOURCES_I18N_EN =  {
    [SOURCES_I18N_KEYS.facebook_dropdown_header_label]:   "Facebook",
    [SOURCES_I18N_KEYS.facebook_disconnect_button_label]: "(Disconnect)",
    [SOURCES_I18N_KEYS.forums_dropdown_header_label]:     "Forums (Truescope Data)"
  }


// WEBPACK FOOTER //
// ./src/locales/en/features/sources/sources.i18n.en.js